import {
	type UseTitleGenerationOnPasteProps,
	useTitleGenerationOnPaste,
} from './hooks/useTitleGenerationOnPaste.tsx';

export const TitleGenerationOnPaste = ({
	contentId,
	textAreaRef,
	isEditorEmpty,
	userOffline,
	flags,
	i18n,
	formatMessage,
}: UseTitleGenerationOnPasteProps) => {
	useTitleGenerationOnPaste({
		contentId,
		textAreaRef,
		isEditorEmpty,
		userOffline,
		flags,
		i18n,
		formatMessage,
	});

	return null;
};
